/** Default sort used by the system settings list screen (client-side only). */
export const SETTING_LIST_DEFAULTS = {
  sortBy: 'id',
  sortDir: 'asc',
};

/** Sort keys exposed by the settings table column headers. */
export const SETTING_SORT_FIELDS = {
  id: 'id',
  percentage: 'percentage',
  status: 'status',
};

/**
 * Computes the next client-side sort when a column header is clicked.
 * Same column toggles asc/desc; a new column always starts asc.
 */
export function getNextSettingSort(columnKey, currentSortBy, currentSortDir) {
  const sortBy = columnKey || SETTING_LIST_DEFAULTS.sortBy;
  if (currentSortBy === sortBy) {
    return {
      sortBy,
      sortDir: currentSortDir === 'asc' ? 'desc' : 'asc',
    };
  }
  return { sortBy, sortDir: 'asc' };
}

/** Resolves a row field value for client-side column sorting. */
function settingSortValue(row, sortBy) {
  switch (sortBy) {
    case SETTING_SORT_FIELDS.percentage:
      return Number(row.percentage) || 0;
    case SETTING_SORT_FIELDS.status:
      return row.status ?? '';
    case SETTING_SORT_FIELDS.id:
    default:
      return Number(row.id) || 0;
  }
}

/**
 * Sorts setting rows in memory — no API round-trip.
 */
export function sortSettingsLocally(rows, sortBy, sortDir) {
  const list = Array.isArray(rows) ? [...rows] : [];
  const dir = sortDir === 'desc' ? -1 : 1;
  const field = sortBy || SETTING_LIST_DEFAULTS.sortBy;

  list.sort((a, b) => {
    const av = settingSortValue(a, field);
    const bv = settingSortValue(b, field);
    if (typeof av === 'number' && typeof bv === 'number') {
      return (av - bv) * dir;
    }
    return String(av).localeCompare(String(bv), undefined, { sensitivity: 'base' }) * dir;
  });

  return list;
}
